/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: API's interceptors
  Date: April 2020
**/

import axios from 'axios';
import LocalStorageService from '../services/localStorage';
const localStorageService = LocalStorageService.getService();
import moment from 'moment';
import { globalDateEntity } from '../constants/applicationConstants';
import { stringConstants } from '../constants/stringConstants';
const openSnackbar = (msg) => {
  // Get the snackbar DIV
  let x = document.querySelector('#snackbar');
  x.innerHTML = msg;
  // Add the "show" class to DIV
  x.className = 'show';
  // After 3 seconds, remove the show class from DIV
  setTimeout(function () {
    x.className = x.className.replace('show', '');
  }, 3000);
};

// TODO temporary changes, unless login api is done
const headers = {
  'Content-type': 'application/json',
  'Cache-Control': `no-cache`,
  Authorization: `Bearer ${localStorageService.getAccessToken()}`,
};
const baseUrl = process.env.REACT_APP_API_URL;
const API = axios.create({
  baseURL: baseUrl,
  headers,
});

const callList = [];

const toggleIndicator = (url, type) => {
  // document.querySelector('.showLoader').style.backgroundColor = localStorageService.getColor();
  // document.querySelector('.rect1').style.color = localStorageService.getColor();
  // document.querySelector('.rect2').style.backgroundColor = localStorageService.getColor();
  // document.querySelector('.rect2').style.color = localStorageService.getColor();
  // document.querySelector('.rect3').style.backgroundColor = localStorageService.getColor();
  // document.querySelector('.rect3').style.color = localStorageService.getColor();

  // document.querySelector('.spinner').style.color = localStorageService.getColor();
  document.querySelector('.spinner').style.stroke = localStorageService.getColor();

  if (type) {
    callList.push(`${baseUrl}/${url}`);
    // if ((!url.match(/diagnostic-codes/g)) && (!url.match(/users\/login/g))) {
    document.querySelector('.showLoader').style.display = 'flex';
  }

  if (!type) {
    const index = callList.indexOf(`${baseUrl}/${url}`);
    if (index !== -1) {
      callList.splice(index, 1);
    }
    if (callList.length === 0) {
      document.querySelector('.showLoader').style.display = 'none';
    }
  }
};

API.interceptors.request.use(
  (config) => {
    if (
      config.url != 'users/notifications' &&
      window.location.pathname != '/'
    ) {
      // console.log('config.url', config);
      if(config.url.indexOf('next_page=') === -1) {
        toggleIndicator(config.url, true);
      }
    }
    // TODO: need to move auth token stamping logic in interceptor
    // if (config.method.toLowerCase() === 'delete') {
    //   config.headers['Authorization'] = `Bearer ${localStorageService.getAccessToken()}`
    // }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const expireSession = () => {
  LocalStorageService.clearToken();
  setTimeout(function () {
    window.location = '/login';
  }, 1000);
}
const logout = () => {
  axios.post(`${baseUrl}/users/logout`, { 
    "token": localStorage.getItem('refreshToken'),
    "client_id": localStorage.getItem('clientID')
  })
  .then((res) => {
    expireSession();
  });
}

API.interceptors.response.use(
  (response) => {
    toggleIndicator(response.config.url, false);
    if (response.config.method === 'get' && response.data.data && typeof response.data.data === 'object') {
      const responseData = response.data.data.items
        ? response.data.data.items
        : response.data.data.associations &&
          Array.isArray(response.data.data.associations)
        ? response.data.data.associations
        : [];
      for (let item of responseData) {
        item.effectivedate = item.effectivedate
          ? moment.utc(item.effectivedate).format(globalDateEntity.dateFormat)
          : null;
        item.inactivedate = item.inactivedate
          ? moment.utc(item.inactivedate).format(globalDateEntity.dateFormat)
          : null;
      }
      if (responseData.length === 0) {
        if (response.data.data.effectivedate) {
          response.data.data.effectivedate = moment
            .utc(response.data.data.effectivedate)
            .format(globalDateEntity.dateFormat);
        } else {
          response.data.data.effectivedate = null;
        }
        if (response.data.data.inactivedate) {
          response.data.data.inactivedate = moment
            .utc(response.data.data.inactivedate)
            .format(globalDateEntity.dateFormat);
        } else {
          response.data.data.inactivedate = null;
        }
      }
    }
    return response;
  },
  async function (error) {
    if (error && error.response === undefined) {
      openSnackbar(stringConstants.NetWorkError);
    } else if (
      error &&
      error.response &&
      error.response.status &&
      (error.response.status === 415 || error.response.status === 416)
    ) {
      openSnackbar(JSON.stringify(error.response.data.error));
    } else if (
      error &&
      error.response &&
      error.response.status &&
      (error.response.status === 411 || error.response.status === 417)
    ) {
      window.location = '/not-found';
    }
    const originalRequest = error.config;
    toggleIndicator(arguments[0].config.url, false);
    let timeOutValue = 200;
    if (error.response.status === 403) {
      // incase of 403 error code, terminate the session and redirect user to login page.
      /* const UserInfo = JSON.parse(localStorageService.getUserInfo());
      if (UserInfo.is_sso_user?.toUpperCase() == 'Y') {
        let sso_refresh_token =
          process.env.REACT_APP_SSO_LOGIN_URL.replace(
            '/login?',
            '/authorize?',
          ) +
          '&identity_provider=' +
          UserInfo.identity_provider;
        LocalStorageService.clearToken();
        window.location = sso_refresh_token;
        return;
      } */
      if (
        error.response.data.error_type !== 'login_failed' &&
        !error.response.data.error.includes('suspended')
      ) {
        await axios
          .post(`${baseUrl}/users/generate-token`, {
            refreshToken: localStorage.getItem('refreshToken'),
            client_id: localStorage.getItem('clientID'),
          })
          .then((res) => {
            if (
              (res?.data?.data?.error &&
                res.data.data.error.toUpperCase().replace(/[ _]/g, '-') ===
                  'NOTAUTHORIZEDEXCEPTION:-INVALID-REFRESH-TOKEN') ||
              (res?.data?.data?.error &&
                res.data.data.error.toUpperCase().replace(/[ _]/g, '-') ===
                  'NOTAUTHORIZEDEXCEPTION:-REFRESH-TOKEN-HAS-EXPIRED')
            ) {
              openSnackbar(res.data.data.error);
              logout();
            } else {
              if (res.data.data.AuthenticationResult?.AccessToken) {
                localStorage.setItem(
                  'accessToken',
                  res.data.data.AuthenticationResult.AccessToken,
                );
                if (error.response.config.url === 'users/me') {
                  window.location = '/';
                }
              }
            }
          })
          .catch((err) => {
            // console.log("Err", error.response, error.response.data);
            openSnackbar(error?.response?.data?.error);
            // logout();
            expireSession();
          });
        originalRequest._retry = true;
        originalRequest.headers['Authorization'] =
          'Bearer ' + `${localStorage.getItem('accessToken')}`;

        return axios(originalRequest);
      } else if (error.response.data.error_type === 'unauthorized_access') {
        if (error.response.data.error.includes('suspended')) {
          openSnackbar('Your account has been suspended');
        }
      }
      LocalStorageService.clearToken();
      setTimeout(() => {
        window.location = '/login';
      }, timeOutValue);
    }

    // console.log('error==', error.response.data.error)
    
    return Promise.reject(error);
  },
);

export default API;
